import { redirectToHomeIfNotAdmin } from '@/ccpv2/router/guards';
import {
  redirectToHomeIfNoAccess,
  redirectToHomeIfNoMyPortalAccess,
  redirectToHomeIfNoSettingsAccess,
  redirectToListIfNoSummaryAccess,
  refreshCompanySettings,
} from '@/people/router/guard';

const SummaryPage = () => import('@/people/pages/summary.vue');
const ListPage = () => import('@/people/pages/list.vue');
const EmployeePortalPage = () => import('@/people/pages/employee-portal.vue');
const PeopleSettingsPage = () => import('@/people/pages/people-settings.vue');
const EmployeePortalSettingsPage = () => import('@/people/pages/settings/employee-portal.vue');
const PeopleColumnsSettingsPage = () => import('@/people/pages/settings/columns-settings.vue');
const PeopleAccessSettingsPage = () => import('@/people/pages/settings/people-access.vue');
const ManagerPermissionsSettingsPage = () => import('@/people/pages/settings/manager-permissions.vue');
const LayoutPeople = () => import('@/people/layouts/layout-people.vue');

export const peopleRoutes = [
  {
    path: '',
    component: LayoutPeople,
    children: [
      {
        path: '/people',
        name: 'people',
        redirect: { name: 'people-list' },
        beforeEnter: redirectToHomeIfNoAccess,
      },
      {
        path: '/people/summary',
        name: 'people-summary',
        component: SummaryPage,
        beforeEnter: [redirectToHomeIfNoAccess, redirectToListIfNoSummaryAccess],
      },
      {
        path: '/people/list',
        name: 'people-list',
        component: ListPage,
        beforeEnter: redirectToHomeIfNoAccess,
      },
      {
        path: '/people/settings',
        name: 'people-settings',
        redirect: { name: 'people-employee-portal-settings' },
        component: PeopleSettingsPage,
        beforeEnter: redirectToHomeIfNoSettingsAccess,
        children: [
          {
            path: 'employee-portal',
            name: 'people-employee-portal-settings',
            component: EmployeePortalSettingsPage,
            beforeEnter: redirectToHomeIfNoSettingsAccess,
          },
          {
            path: 'manager-permissions',
            name: 'people-manager-permissions-settings',
            component: ManagerPermissionsSettingsPage,
            beforeEnter: [redirectToHomeIfNotAdmin],
          },
          {
            path: 'columns',
            name: 'people-settings-columns',
            component: PeopleColumnsSettingsPage,
            beforeEnter: [redirectToHomeIfNoSettingsAccess],
          },
          {
            path: 'people-access',
            name: 'people-access-settings',
            component: PeopleAccessSettingsPage,
            beforeEnter: [redirectToHomeIfNotAdmin],
          },
        ],
      },
    ],
  },
  {
    path: '/employee-portal',
    name: 'employee-portal',
    component: EmployeePortalPage,
    beforeEnter: [refreshCompanySettings, redirectToHomeIfNoMyPortalAccess],
  },
  {
    path: '/employee-portal/:employeeId',
    name: 'employee-portal-id',
    component: EmployeePortalPage,
    beforeEnter: [refreshCompanySettings, redirectToHomeIfNoAccess],
  },
];
